import { Alert, Button, Collapse, Stack } from '@mui/material'
import React, { useState } from 'react'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { useTranslation } from '../../../../../common/hooks/helper/useTranslation'
import { useBlackButtonStyle } from '../../../../../utils/styles/useBlackButtonStyle'

export const PatientDetailsHeader: React.FC = () => {
  const { t } = useTranslation()
  const classes = useBlackButtonStyle()

  const [showInfo, setShowInfo] = useState<boolean>(false)

  return (
    <Stack pt={2} gap={1}>
      <Stack direction="row">
        <Button
          size="small"
          color="primary"
          variant="text"
          startIcon={<InfoOutlinedIcon />}
          sx={{ paddingX: 1, minWidth: 'fit-content', ml: 'auto' }}
          classes={{ textPrimary: classes.textPrimary }}
          onClick={() => setShowInfo(!showInfo)}
        >
          {t('doctor:patientProfile.infoButton')}
        </Button>
      </Stack>

      <Collapse in={showInfo} unmountOnExit>
        <Alert onClose={() => setShowInfo(false)} severity="info">
          {t('doctor:patientProfile.description')}
        </Alert>
      </Collapse>
    </Stack>
  )
}
